import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';
import { SearchColumnDef } from '@/components/custom/erp';
import { formatRoundedNumber } from '@/lib/formatUtils';
import { Checkbox } from '@/components/ui/checkbox';

export const getDataTableColumns = (): DataTableColumn[] => [
  {
    field: 'so_ct',
    headerName: 'Số c/từ nội bộ',
    width: 160
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 160
  },
  {
    field: 'ten_ct',
    headerName: 'Tên chứng từ',
    width: 160
  },
  {
    field: 'ma_tthddt',
    headerName: 'Trạng thái HĐĐT',
    width: 160
  },
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 160
  },
  {
    field: 'ten_kh_thue',
    headerName: 'Họ tên người mua hàng',
    width: 240
  },
  {
    field: 'unit_id',
    headerName: 'Tên đơn vị',
    width: 160
  },
  {
    field: 'ma_so_thue',
    headerName: 'Mã số thuế',
    width: 160
  },
  {
    field: 'dia_chi',
    headerName: 'Địa chỉ',
    width: 240
  },
  {
    field: 't_tt_nt',
    headerName: 'Tổng tiền',
    width: 160,
    renderCell: params => formatRoundedNumber(params.value as number | string)
  },
  {
    field: 'dien_thoai',
    headerName: 'Điện thoại',
    width: 160
  },
  {
    field: 'e_mail',
    headerName: 'Email',
    width: 160
  },
  {
    field: 'tknh',
    headerName: 'Tài khoản ngân hàng',
    width: 160
  },
  {
    field: 'ten_nh',
    headerName: 'Tên ngân hàng',
    width: 160
  },
  {
    field: 'ma_pttt',
    headerName: 'Ph/thức thanh toán',
    width: 160
  },
  {
    field: 'noi_dung',
    headerName: 'Nội dung',
    width: 240
  },
  {
    field: 'van_ban_thoa_thuan',
    headerName: 'Văn bản thỏa thuận',
    width: 240
  },
  {
    field: 'ngay_thoa_thuan',
    headerName: 'Ngày thỏa thuận',
    width: 160
  },
  {
    field: 'ma_nt',
    headerName: 'Ngoại tệ',
    width: 160
  }
];
export const getInputTableColumns = (): DataTableColumn[] => [
  {
    field: 'column',
    headerName: 'Cột',
    width: 180
  },
  {
    field: 'columnName',
    headerName: 'Tên cột',
    width: 200
  },
  {
    field: 'columnNameEnglish',
    headerName: 'Tên tiếng anh',
    width: 200
  },
  {
    field: 'width',
    headerName: 'Độ rộng',
    width: 200
  },
  {
    field: 'format',
    headerName: 'Định dạng',
    width: 200
  },
  {
    field: 'align',
    headerName: 'Căn chỉnh',
    width: 200
  },
  {
    field: 'bold',
    headerName: 'In đậm',
    width: 200
  },
  {
    field: 'italic',
    headerName: 'Nghiêng',
    width: 200
  },
  {
    field: 'total',
    headerName: 'Tổng',
    width: 200
  }
];

export const donViSearchColumns: SearchColumnDef[] = [
  {
    field: 'checkbox',
    headerName: '',
    width: 50,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderHeader: () => <Checkbox />,
    renderCell: params => <Checkbox checked={params.row.checkbox} />
  },
  { field: 'ma_don_vi', headerName: 'Mã đơn vị', width: 150 },
  { field: 'ten_don_vi', headerName: 'Tên đơn vị', width: 250 },
  { field: 'id', headerName: 'ID', width: 150 }
];
